<script>
import PanelFooter from '@components/footer/panel-footer.vue';
import {
  adminPanelComputed,
  clientProgramMethods,
  adminPanelMethods,
} from '@state/helpers';

export default {
  components: {
    PanelFooter,
  },
  props: {
    noteItem: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  data() {
    return {
      isLoadingCreate: false,
      isLoadingRemove: false,
      footerWidth: null,
      newNote: '',
    };
  },
  computed: {
    ...adminPanelComputed,
  },
  mounted() {
    window.addEventListener('resize', this.init);
  },
  destroyed() {
    window.removeEventListener('resize', this.init);
  },
  methods: {
    ...clientProgramMethods,
    ...adminPanelMethods,
    init() {
      if (this.$refs && this.$refs.notePreview) {
        this.footerWidth = this.$refs.notePreview.offsetWidth - 55;
      }
    },
    async deleteNote() {
      this.isLoadingRemove = true;
      const dayId = this.panelContent.data.day.programDay_id;
      const weekId = this.panelContent.data.week._id;
      const programId = this.panelContent.data.week.program_id;

      const payload = { programId, weekId, dayId };

      if (programId && weekId && dayId) {
        await this.deleteTrainerNote(payload)
          .then((res) => {
            if (res.success) {
              this.isLoadingRemove = false;
              this.setHideAdminPanel();
            } else {
              // TODO: maybe display error creation ?
              this.isLoadingRemove = false;
              this.setHideAdminPanel();
            }
          })
          .catch((e) => console.log(e));
      }
    },
    async updateNote() {
      this.isLoadingCreate = true;
      const note = this.newNote;
      const targetedDay = this.panelContent.data.day.dayNumber;
      const targetedWeek = this.panelContent.data.week.weekNumber;
      const programId = this.panelContent.data.week.program_id;

      const payload = {
        source: {
          type: 'trainerNote',
          message: note,
        },
        programDestination: {
          weekNumber: targetedWeek,
          dayNumber: targetedDay,
        },
      };

      const trainerNoteObj = { programId, payload };

      if (targetedWeek && targetedWeek && programId) {
        await this.addUpdateTrainerNote(trainerNoteObj)
          .then((res) => {
            if (res.success) {
              this.isLoadingCreate = false;
              this.setHideAdminPanel();
            } else {
              // TODO: maybe display error creation ?
              this.isLoadingCreate = false;
              this.setHideAdminPanel();
            }
          })
          .catch((e) => console.log(e));
      }
    },
    handleUpdateNote(e) {
      this.newNote = e.target.value;
    },
  },
  watch: {
    isAdminPanelActive() {
      this.newNote = '';
    },
  },
};
</script>

<template>
  <div class="workout-preview" ref="notePreview">
    <div :class="['workout-preview-content']">
      <div>
        <span class="message-title">Note:</span>
        <BaseInputTextarea
          @input="handleUpdateNote"
          :value="newNote ? newNote : noteItem"
          class="message"
          placeholder="Type your note here..."
        />
        <!-- <span class="message-title">Message:</span>
      <BaseInputTextTextArea inputType="text" placeholder="Name" /> -->
      </div>
      <PanelFooter :footerWidth="footerWidth">
        <template slot="footerLeftTitle" class="left-title">
          <span class="left-title"> </span>
        </template>
        <template slot="footerRightTitle">
          <div>
            <BaseButton
              v-if="noteItem || newNote !== ''"
              type="button"
              class="btn-primary btn-clear"
              @click="deleteNote"
            >
              <BaseIcon v-if="!isLoadingRemove" name="trash" />
              <BaseIcon v-if="isLoadingRemove" name="sync" spin />
              Remove
            </BaseButton>
            <span class="divider-vertical">&nbsp;</span>
            <BaseButton
              type="button"
              class="btn-primary btn-clear"
              @click="updateNote"
            >
              <BaseIcon v-if="isLoadingCreate" name="sync" spin />
              <BaseIcon v-if="!isLoadingCreate" name="save" />
              Save
            </BaseButton>
          </div>
        </template>
      </PanelFooter>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.workout-preview-content {
  padding: 3rem;

  .panel-footer {
    margin-left: unset;
  }

  ::v-deep .panel-footer {
    svg {
      margin-right: 1rem;
      path {
        fill: white;
      }
    }
    .btn-primary {
      padding-left: 1.8rem;
      padding-right: 1.8rem;
    }
  }

  .message-title {
    color: $color-black-one;
    font-size: 21px;
    font-style: normal;
    font-weight: 800;
    // padding-bottom: 3rem;
    letter-spacing: -0.3px;
    line-height: 24px;

    /* or 114% */
    margin-bottom: 3rem;
  }

  .message {
    padding-top: 2.5rem;
    ::v-deep .input-textarea {
      height: 30rem !important;
      line-height: 2.5rem;
    }
  }
}
</style>
